<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Point disbursement</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item">Reports</li>
              <li class="breadcrumb-item active">Point disbursement report</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <div class="btn-toolbar pull-right">
              <a
                href="javascript:void(0)"
                class="btn btn-info"
                @click="show_filter = !show_filter"
              ><i class="fa fa-filter"></i>Filter</a
              >
            </div>

            <!--<div class="card-tools">
              <button class="btn btn-info" @click="exportReport()">
                <i class="fas fa-download"></i> Export
              </button>
            </div>-->
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="show_filter">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="username"
                    >Username</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="username"
                        class="form-control"
                        v-model="filter.username"
                        placeholder="Username"
                      />
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="disbursed_by"
                    >Disbursed by</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="disbursed_by"
                        class="form-control"
                        v-model="filter.disbursed_by"
                        placeholder="disbursed_by username"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="disbursement_data"
                    >Date range</label
                    >
                    <div class="col-md-9">
                      <date-picker
                        type="datetime"
                        input-class="form-control"
                        v-model="filter.disbursement_data"
                        range
                        lang="en"
                        format="YYYY-MM-DD"
                        confirm
                        id="disbursement_data"
                        value-type="YYYY-MM-DD"
                      ></date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn btn-common m-2px">
                        Search
                      </button>
                      <button
                        type="reset"
                        class="btn btn-warning"
                        @click="resetFilter()"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body table-responsive-md p-0">
            <table class="table">
              <thead>
              <tr>
                <th style="width: 10px">ID</th>
                <th>Disbursement Date <sort-icons :_sort="'disbursement_data'"/></th>
                <th>Disbursed by</th>
                <th>Name</th>
                <th>Username</th>
                <th>Amount <sort-icons :_sort="'amount'"/></th>
                <th>Description</th>
                <th>Attachments</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(each, index) in reports.data">
                <td>{{ each.id }}</td>
                <td>{{ each.disbursement_data | moment }}</td>
                <td>{{ each.disbursed_by.username }}</td>
                <td>{{ each.user.name }}</td>
                <td>{{ each.user.username }}</td>
                <td>{{ each.amount | afterDecimal2 }}</td>
                <td>{{ each.description }}</td>
                <td>
                  <a :href="each.attachments | apiFileLink" target="_blank" v-if="each.attachments">View</a>
                </td>
              </tr>
              </tbody>
            </table>

            <div class="p-4" v-if="_.isEmpty(reports.data)">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
          <div class="card-footer">
            <vue-pagination
              :pagination="reports"
              v-if="reports.total > reports.per_page"
              @paginate="init()"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent"
import {LearningReportApi} from "@/services/api"
import SortIcons from "@/components/utils/SortIcons"

import DatePicker from "vue2-datepicker"
import "vue2-datepicker/index.css"
import axios from "axios"
import fileDownload from "js-file-download"

export default {
  name: "PointDisbursementReport",
  metaInfo: {
    title: "Point Disbursement Report | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons
  },
  data: () => ({
    reports: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    show_filter: false,
    filter: {},
    is_loading: false,
    api_root: process.env.VUE_APP_API_ROOT_URL,
  }),
  methods: {
    init() {
      this.filter = JSON.parse(JSON.stringify(this.$route.query))
      if (!_.isEmpty(this.filter)) this.show_filter = true
      this.is_loading = true
      let params = {...this.filter, ...this.$route.query}
      LearningReportApi.walletDisbursement(params)
        .then((reports) => {
          this.reports = reports
        })
        .finally(() => {
          this.is_loading = false
        })
    },
    resetFilter() {
      this.$router.push({path: this.$route.path}).catch(() => {
      })
    },
    async getFilterData() {
      this.$router
        .push({
          path: this.$route.fullPath,
          query: this.filter,
        })
        .catch((err) => {
          console.log(err)
        })
    },
    exportReport: function () {
      this.is_loading = true
      axios
        .get("/reports/point-disbursement-export", {
          params: this.filter,
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, "Point-disbursement-report.xlsx")
        })
        .catch((error) => {
          console.log("error " + error)
        })
        .finally(() => {
          this.is_loading = false
        })
    }
  },
  mounted() {
    this.init()
    this.$root.$on('sort-data', () => {
      this.$root.$emit('show-icon')
    })
  },
  watch: {
    '$route.query'() {
      this.init()
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a")
    },
    afterDecimal2(data) {
      return parseFloat(data).toFixed(2)
    },
    apiFileLink(data) {
      if(data != '')
        return process.env.VUE_APP_API_ROOT_URL + '/uploads/' + data
      else
        return 'javascript:void(0)'
    }
  },
};
</script>
